
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import LoadModule from "@/store/modules/barcodeSystem/load";
import notifications from "@/lib/notifications";
import { LoadListFilters } from "@/models/api/barcodeSystem/loads/get";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const loadModuleState = getModule(LoadModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class LoadFilters extends Vue {
  localFilters: LoadListFilters = null;

  get filters() {
    return loadModuleState.filters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    loadModuleState.setFilters(JSON.parse(JSON.stringify(this.localFilters)));
    loadModuleState.setLoading(true);
    try {
      await loadModuleState.getLoads({
        pageNumber: 1,
        pageSize: loadModuleState.pageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Loads", "Failed to load barcode loads", ex);
    }

    loadModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return loadModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
